<app-environment-label></app-environment-label>

<router-outlet></router-outlet>
